import { apiGetYearGroups } from '../../common/api/year-groups'

const fetchYearGroups = () => ({
  requestPrefix: 'YEAR_GROUPS:FETCH',
  request: () =>
    apiGetYearGroups({
      include: 'year_group.names,year_group.order'
    })
})

export { fetchYearGroups }
